import { useQuery } from '@hooks/reactQuery';

import { assetCartRequestFullView } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAssetCartRequestList } from '@api/assetCartRequest';

import { endOfDayInUTC, startOfDayInUTC } from '@utils/kpi-utils/date';

import { ASSET_CART_REQUEST } from '@constants/queryKeys';

export const useQueryAssetCartRequestList = () => {
	const {
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		searchValue,
		assetOwnerId,
		assetTypeId,
		assetSubTypeId,
		isAvailableInPeriod,
		fromDate,
		toDate,
	} = useAppSelector(assetCartRequestFullView);

	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [
			ASSET_CART_REQUEST,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			assetOwnerId,
			assetTypeId,
			assetSubTypeId,
			isAvailableInPeriod,
			fromDate,
			toDate,
		],
		queryFn: () => getAssetCartRequestList({
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			assetOwnerId,
			assetTypeId,
			assetSubTypeId,
			isAvailableInPeriod,
			rentFrom: fromDate && startOfDayInUTC(new Date(fromDate)),
			rentTo: toDate && endOfDayInUTC(new Date(toDate)),
		}),
		refetchOnWindowFocus: false,
	});

	return {
		assetCartRequestList: data?.page?.items || [],
		assetOwners: data?.assetOwners || [],
		availableAssetRequestCount: data?.available || 0,
		countOfRecords: data?.page?.count || 0,
		isLoadingAssetCartRequest: isInitialLoading,
		numberOfFutureRequests: data?.numberOfFutureRequests || 0,
		unavailableAssetRequestCount: data?.unavailable || 0,
	};
};
